import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {UtilService} from '../../../shared/service/util.service';
import {NoopEncoder} from "../../../shared/encoder/noop-encoder";

@Injectable({
  providedIn: 'root'
})
export class FinalClientPlaceService {

  constructor(
    private http: HttpClient,
    private utils: UtilService
  ) { }

  getFCPlaceIndexDescription(placeCode: string): Observable<any> {
    let params = new HttpParams();
    if (this.utils.nonNullAndNonUndefined(placeCode)) {
      params = params.append('placeCode', placeCode);
    }
    return this.http.get<any>(environment.baseUrl + `/loc-consum/detalii-completare-index`, {params});
  }

  getElectricalPlaceById(id: number): Observable<any> {
    return this.http.get<any>(environment.loggedInUrl + `/client-final/detalii-loc-consum/${id}`);
  }

  getElectricalPlaceByCode(placeCode: string): Observable<any> {
    let params = new HttpParams({encoder: new NoopEncoder()});
    if (this.utils.nonNullAndNonUndefined(placeCode)) {
      params = params.append('placeCode', encodeURIComponent(placeCode));
    }
    return this.http.get<any>(environment.baseUrl + `/loc-consum/electricitate`, {params});
  }

  getGasPlaceById(id: number): Observable<any> {
    return this.http.get<any>(environment.loggedInUrl + `/client-final/gas/detalii-loc-consum/${id}`);
  }

  getGasPlaceByCode(placeCode: string): Observable<any> {
    let params = new HttpParams({encoder: new NoopEncoder()});
    if (this.utils.nonNullAndNonUndefined(placeCode)) {
      params = params.append('placeCode', encodeURIComponent(placeCode));
    }
    return this.http.get<string>(environment.baseUrl + `/loc-consum/gaz`, {params});
  }
}
